import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PartialRecord } from '../../../core/records/entities/partial-record.class';
import { DialogConfig } from '../../../dynamic-dialog/entities/dialog-config.entity';
import { ShActionGroupComponent } from '../../../elements/components/action-group/action-group.component';
import { NavigationLinkDirective } from '../../../elements/directives/navigation-link/navigation-link.directive';
import { Marker } from '../../entities/marker.entity';

@Component({
    selector: 'sh-cluster-info-dialog',
    templateUrl: './cluster-info-dialog.component.html',
    styleUrls: ['./cluster-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgFor, NgTemplateOutlet, NavigationLinkDirective, NgIf, ShActionGroupComponent, TranslateModule]
})
export class ShClusterInfoDialogComponent implements OnInit {
    public clusterMarkers: Marker<PartialRecord>[];

    constructor(public config: DialogConfig) {}

    ngOnInit(): void {
        this.clusterMarkers = this.config.data.clusterMarkers;
    }
}
